import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IRequestResult } from 'app/common/interfaces';
import { Shortcut } from 'app/layout/common/shortcuts/shortcuts.types';
import ShortcutsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/shortcuts/shortcuts.entity";
import { AbstractService } from 'app/services/abstract.service';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';
import { buildQuery, Ops, where } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { AuthService } from 'app/core/auth/auth.service';

const apiUrl = environment.API_CONFIGURATION_URL;
const moduleName = 'shortcuts';

@Injectable({
  providedIn: 'root',
})
export class ShortcutsService extends AbstractService<
  ShortcutsAttributes,
  Partial<ShortcutsAttributes>,
  Partial<ShortcutsAttributes>
> {
  constructor(
    http: HttpClient,
    private _authService: AuthService,  
  ) {
    super(apiUrl, moduleName, http);
  }

  getAll(): Observable<IRequestResult<ShortcutsAttributes[]>>{
    const filters = [];
    if (this._authService.user?._id) {
      filters.push(where('user_login_id', Ops.eq(this._authService.user._id)));
    }

    const query = buildQuery<ShortcutsAttributes>(
      ...filters
    );
    
    const API_URL: string = apiUrl + `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<ShortcutsAttributes[]>>(API_URL);
  }
}
